// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2oty6","search":"Settings_search__8nU38","filter":"Settings_filter__1JM_g"};